import type { IconProps } from '@ab-core/icon';
import { Icon } from '@ab-core/icon';
import type { FC } from 'react';
import React from 'react';
import { StyledLink, TagTextInnerContainer } from './styled';

export type TagTextProps = {
    iconName: IconProps['name'];
    text?: string;
    href?: string;
};

export const TagText: FC<TagTextProps> = (props) => {
    const { href } = props;

    if (href) {
        return (
            <StyledLink href={href} target="_blank" rel="noreferrer">
                <TagTextInner {...props} />
            </StyledLink>
        );
    }

    return <TagTextInner {...props} />;
};

const TagTextInner: FC<TagTextProps> = (props) => {
    const { text, iconName } = props;

    return (
        <TagTextInnerContainer className="flex">
            <Icon size="SMALL_4" name={iconName} /> {text}
        </TagTextInnerContainer>
    );
};
